module.exports = __webpack_public_path__ + "static/media/greenscene.44cffec7.png";